import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	workPlace: null,
	error: "",
	loading: false,
};

// ADD_workPlace
export const addWorkPlace = createAsyncThunk(
	"workPlace/addWorkPlace",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `workPlace`,
				data: {
					...values,
				},
			});
			toast.success("Country of Issue added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Country of Issue try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_workPlace
export const deleteWorkPlace = createAsyncThunk(
	"workPlace/deleteWorkPlace ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `workPlace/${id}`,
			});

			toast.success("Country of Issue deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Country of Issue try again");
			console.log(error.message);
		}
	}
);

// workPlaceS
export const getAllWorkPlace = createAsyncThunk(
	"workPlace/getAllWorkPlace",
	async () => {
		try {
			const { data } = await axios.get(`workPlace`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateWorkPlace = createAsyncThunk(
	"workPlace/updateWorkPlace",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `workPlace/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Country of Issue updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Country of Issue try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const workPlaceSlice = createSlice({
	name: "workPlace",
	initialState,
	reducers: {
		clearWorkPlace: (state) => {
			state.workPlace = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllWorkPlace ======

		builder.addCase(getAllWorkPlace.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllWorkPlace.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllWorkPlace.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addWorkPlace  ======

		builder.addCase(addWorkPlace.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addWorkPlace.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addWorkPlace.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for workPlace ======

		builder.addCase(updateWorkPlace.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateWorkPlace.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateWorkPlace.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteWorkPlace  ======

		builder.addCase(deleteWorkPlace.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteWorkPlace.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteWorkPlace.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default workPlaceSlice.reducer;
export const { clearWorkPlace } = workPlaceSlice.actions;
